import { I18n } from "@assets/strings";
import React from "react";
import { FallbackProps } from "react-error-boundary";
import styled from "styled-components";
import pencilImg from "@assets/images/auth/pencil.png";
import tabletImg from "@assets/images/auth/tablet.png";
import user2Img from "@assets/images/auth/user-2.png";
import imacImg from "@assets/images/variant-jaangal/auth/imac.png";
import logoPrimary from "@assets/images/variant-jaangal/logo-header.png";
import { Environment } from "@core/config/environment";
import { useIsMobile } from "@utils/hooks";
import { scaledPx } from "@ui/styles/utils";
import { stack } from "./layout";
import { SvgPath } from "@ui/components/shapes/svgPath";

export const ErrorFallback: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
	const isMobile = useIsMobile();
	return (
		<Container>
			<HeaderContainer>
				<HomeButton onClick={() => (window.location.href = "/")}>
					<img src={logoPrimary} />
				</HomeButton>
			</HeaderContainer>
			<SecondContainer>
				<LeftSide style={{ alignItems: "center", height: "732px" }}>
					<Title>
						<div>{I18n.t("404.oops")}</div>
						<div>{I18n.t("404.white_page.message")} 😞</div>
					</Title>
					<Button onClick={resetErrorBoundary}>{I18n.t("404.white_page.button.title")}</Button>
				</LeftSide>
				{!isMobile && (
					<RightSide>
						<Tablet src={tabletImg} />
						<Pen src={pencilImg} />
						<Line
							color="#fff"
							boxSize={[301, 341]}
							path={[
								[0, 132],
								[72, 0],
								[192, 330],
								[304, 282],
							]}
							points={[
								[45, 49],
								[151, 217],
							]}
						/>
						<Computer src={imacImg} />
						<User src={user2Img} />
					</RightSide>
				)}
			</SecondContainer>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100vw;
`;

const HeaderContainer = styled.div`
	top: 0;
	left: 0;
	right: 0;
	box-shadow: 0 2px 34px 0 rgba(0, 0, 0, 0.2);
	z-index: 99;
	padding: 9px 70px;
	@media (max-width: 1000px) {
		padding: 9px 20px;
	}
	> div {
		display: flex;
		align-items: center;
	}
`;

const SecondContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const LeftSide = styled.div`
	flex: 1;
	${stack(36, "center", "flex-start")}
	background-color: #f1f1f1;
	align-items: center;
	height: 732px;
`;

const RightSide = styled.div`
	flex: 1;
	background-color: ${({ theme }) => (Environment.APP_VARIANT === "jaangal" ? theme.colors.primary : "#206af8")};
	position: relative;
	height: 732px;
`;

const Title = styled.div`
	color: ${({ theme }) => (Environment.APP_VARIANT === "jaangal" ? theme.colors.primary : "#206af8")};
	font-size: 3.125rem;
	font-weight: 700;
	@media (max-width: 540px) {
		padding: 20px;
	}
`;

const HomeButton = styled.div`
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 98px;
	height: 39px;

	@media (max-width: 900px) {
		width: 75px;
	}
	img {
		max-width: 100%;
	}
`;

const Line = styled(SvgPath)`
	position: absolute;
	top: ${scaledPx(330)};
	right: 0;
	width: ${scaledPx(301)};
	height: ${scaledPx(341)};
	overflow: visible;
`;
const Computer = styled.img`
	position: absolute;
	top: ${scaledPx(165)};
	right: 0;
	width: ${scaledPx(565)};
`;
const Tablet = styled.img`
	position: absolute;
	top: ${scaledPx(425)};
	right: ${scaledPx(246)};
	width: ${scaledPx(222)};
`;
const Pen = styled.img`
	position: absolute;
	top: ${scaledPx(458)};
	right: ${scaledPx(196)};
	width: ${scaledPx(11)};
`;

const User = styled.img`
	position: absolute;
	top: ${scaledPx(628)};
	right: ${scaledPx(75)};
	width: ${scaledPx(65)};
`;

const Button = styled.button`
	background-color: ${({ theme }) => (Environment.APP_VARIANT === "jaangal" ? theme.colors.primary : "#e83636")};
	color: #ffffff;
	font-family: Sora;
	font-size: 0.9375rem;
	font-weight: 700;
	cursor: pointer;
	border: none;
	outline: none;
	border-radius: 6px;
	padding: 8px 40px;
	line-height: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
`;
